<template>
    <div class="date-picker">
        <h4 class="def-title-4">Дата народження</h4>
        <div class="date-picker__block">
            <input v-if="this.result.name && day && month && year || 1" type="hidden"
                   :name="this.result.name" :value="(day && month && year || 1)? showHiddenData : null">
            <date-select :title="title.DayTitle" :result="getDaysInMonth" @changeValue="handlerChangeDate" />
            <date-select :title="title.MonthTitle" :result="getMonthInYear" @changeValue="handlerChangeMonth" />
            <date-select :title="title.YearTitle" :result="getYears" @changeValue="handlerChangeYear" />
        </div>

    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'date-picker',
        props: {
            result: { type: Object }
        },
        data() {
            return {
                date: this.result?.value ? this.parseDate(this.result.value) : new Date(),
                day: null,
                month: null,
                year: null
            }
        },
        computed: {
            ...mapState({
                title: ({personalCabinet}) => personalCabinet.data?.messages,
            }),
            showHiddenData() {
                let r = new Intl.DateTimeFormat().format(new Date(this.year, this.month, this.day));
                return r;
            },
            getDaysInMonth() {
                try {
                    const lastDayOfMonth = new Date(this.date.getFullYear(), this.month +1, 0).getDate();
                    let daysArr = [];
                    // let daysArr = [{
                    //     value: 'День',
                    //     active: !this.day
                    // }];
                    for (let i = 1; i <= lastDayOfMonth; i++) {
                        daysArr.push({
                            value: i,
                            active: i === this.date.getDate() && this.day
                        });
                    }
                    return daysArr;
                } catch (err) {
                    console.error(err);
                    return [];
                }
            },
            getMonthInYear() {
                try {
                    // const month = 12;
                    const month = this.result.dopInfo.monthLabel;
                    const monthArr = [];
                    // let years = [{
                    //     value: 'Рік',
                    //     active: !this.year
                    // }];
                    month.forEach( (el, i) => {
                        monthArr.push({
                            value: el,
                            active: i === this.month && this.month,
                        })
                    })
                    return monthArr;
                } catch (err) {
                    console.error(err);
                    return []
                }
            },
            getYears() {
                try {
                    const startYear = 1900;
                    let years = [];
                    // let years = [{
                    //     value: 'Рік',
                    //     active: !this.year
                    // }];
                    for (let i = startYear; i <= new Date().getFullYear(); i++) {
                        years.push({
                            value: i,
                            active: i === this.date.getFullYear() && this.year
                        });
                    }
                    return years;
                } catch (err) {
                    console.error(err);
                    return [];
                }
            }
        },
        methods: {
            handlerChangeDate(value) {
                if (typeof value === 'number') {
                    this.date.setDate(value);
                    this.date = new Date(this.date);
                    this.day = value;
                } else {
                    this.day = null;
                }

            },
            handlerChangeMonth(value) {
                if (typeof value === 'number') {
                    const lastDayOfMonth = new Date(this.date.getFullYear(), value+1, 0).getDate();
                    if(this.day>lastDayOfMonth) {
                        this.day = 1;
                        this.date.setDate(this.day);

                    }
                    this.date.setMonth(value);
                    this.date = new Date(this.date);
                    this.month = value;
                } else {
                    this.month = null;
                }
            },
            handlerChangeYear(value) {
                if (typeof value === 'number') {
                    this.date.setFullYear(value);
                    this.date = new Date(this.date);
                    this.year = value;
                } else {
                    this.year = null;
                }
            },
            parseDate(input) {
                //const parts = input.match(/(\d+)/g);
                return new Date(input);
            }
        },
        created() {
            if (this.result.value) {
                this.day = this.date.getDate();
                this.month = this.date.getMonth();
                this.year = this.date.getFullYear();
            }
        },
        mounted() {
            this.getDaysInMonth;
            this.getMonthInYear;
            this.getYears;
        },
        filters: {
            formatDate(date) {
                return new Intl.DateTimeFormat().format(date)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .date-picker{
        margin-top: 32px;
        margin-bottom: 24px;
        &__block{
            display: grid;
            grid-template-columns: 1fr;
            grid-row-gap: 8px;
            @include point-md{
                grid-template-columns: 1fr 2fr 1fr;
                grid-column-gap: 8px;
            }
        }
        .def-title-4{
            margin-bottom: 8px;
        }
    }
</style>